<button class="flex items-center border rounded-full px-28 py-2 mx-auto hover:border-grey" [transloco]="label"
  (click)="logout()"></button>